import React from 'react';

const SignupText = () => (
  <div className="col s12 m6 basic-fee hide">
    <h2>Basic</h2>
    <h5>19.95% payout fee</h5>
    <div className="divider" />
    <p>
Free access to browse all settlements and
      enroll in the claims you qualify for, all on
      Collectively's easy-to-use platform.

    </p>
    <ul>
      <li className="col s12">
File claims using Collectively's
        tailored system

      </li>
      <li className="col s12 ">Dashboard Access</li>
    </ul>

  </div>
);

export default SignupText;
